import { ArrowLeft, ArrowRight } from "lucide-react";

import { Button } from "@src/shared/components/ui/button";
import { Spinner } from "@src/shared/components/ui/spinner";

export function SignUpStepFooter({
  ctaLabel,
  secondaryLabel,
  ctaDisabled = false,
  ctaLoading = false,
  hideBack = false,
  hideSkip = false,
  onBack,
  onContinue,
  onSecondary,
  onSkip,
  submit = false,
}: {
  ctaLabel: string;
  secondaryLabel?: string;
  ctaDisabled?: boolean;
  ctaLoading?: boolean;
  hideBack?: boolean;
  hideSkip?: boolean;
  onBack?: () => void;
  onContinue?: () => void;
  onSecondary?: () => void;
  onSkip?: () => void;
  submit?: boolean;
}) {
  return (
    <div className="mt-[28px] flex w-full max-w-[345px] flex-col items-center gap-3">
      <Button
        className="h-[42px] w-full rounded-[9px] text-[13.5px] font-semibold"
        disabled={ctaDisabled || ctaLoading}
        onClick={submit ? undefined : onContinue}
        type={submit ? "submit" : "button"}
      >
        {ctaLoading ? (
          <Spinner className="text-primary-foreground" size="sm" />
        ) : null}
        {ctaLabel}
        {!ctaLoading ? (
          <ArrowRight className="size-4" aria-hidden="true" />
        ) : null}
      </Button>

      {secondaryLabel ? (
        <Button
          className="h-[38px] w-full rounded-[9px] text-[13px] font-semibold"
          disabled={ctaLoading}
          onClick={onSecondary}
          type="button"
          variant="outline"
        >
          {secondaryLabel}
        </Button>
      ) : null}

      <div className="flex items-center justify-center gap-4 text-[13px] font-medium text-muted-foreground">
        {!hideBack ? (
          <button
            className="inline-flex items-center gap-1 rounded-md underline-offset-4 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            onClick={onBack}
            type="button"
          >
            <ArrowLeft className="size-[13px]" aria-hidden="true" />
            Back
          </button>
        ) : null}
        {!hideSkip ? (
          <button
            className="rounded-md underline underline-offset-2 hover:text-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring"
            onClick={onSkip}
            type="button"
          >
            Skip setup
          </button>
        ) : null}
      </div>
    </div>
  );
}
